module.exports = "::ng-deep .invalid .form-group {\n  margin-bottom: 0 !important; }\n\n::ng-deep .invalid input {\n  border: none !important; }\n\n::ng-deep .invalid .input-group, ::ng-deep .invalid select, ::ng-deep .invalid > input {\n  border: 1px solid #b94a48 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/field-validation-message/field-validation-message.component.scss
// module id = ./src/app/shared/components/field-validation-message/field-validation-message.component.scss
// module chunks = main